module.exports = __webpack_public_path__ + "img/20200302153938209.f03ce4ef.jpg";